<div class="densest">
  <div>
    <label class="textarea-label" for="{{ id }}"
      >{{ label }}<span *ngIf="required"> *</span></label
    >
  </div>
  <mat-form-field appearance="outline" class="textarea-form-field">
    <textarea
      matInput
      [id]="id"
      [placeholder]="placeholder"
      [formControl]="control"
      [attr.aria-invalid]="isInvalid"
      [attr.aria-describedby]="isInvalid ? errorId : describedBy || null"
    ></textarea>
    <mat-icon class="textarea-icon" matSuffix *ngIf="isInvalid"
      >error_outline</mat-icon
    >
    <mat-error [id]="errorId">{{ errorText }}</mat-error>
  </mat-form-field>
</div>
